var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm._classes},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.value)+" second"+_vm._s(_vm.value !== 1 ? 's' : '')+" ")]}),_vm._t("icon",function(){return [_c('b-icon',{attrs:{"icon":_vm.icon,"type":`is-${_vm.qualityRating}`}})]}),_vm._t("message",function(){return [_vm._v(" "+_vm._s(_vm.message)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }